import * as types from '../mutation-types'
import { api } from '@/modules/api'

const actions = {
  async editSettings ({commit}, settings) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.agenda.editSettings(), { ...settings })
      this.dispatch('showResultSuccessMessage')
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Settings wasn\'t added')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

export default {
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/agenda-settings.js